import { Box, Card } from '@zillow/constellation';
import React from 'react';

import type { ExpertiseCardProps } from './AuthorPage.types';
import Expertise from './Expertise';

/**
 * Card wrapper for the author's expertise tags.
 */
const ExpertiseCard: React.FC<ExpertiseCardProps> = ({ expertise }) => {
    return (
        <Box
            as={Card}
            sx={{ '&&&&': { padding: '$spacing.md' } }}
            cardType="secondary"
        >
            <Expertise expertise={expertise} />
        </Box>
    );
};

export default ExpertiseCard;
